import {
  FETCH_MY_STUDENTS_REQUEST,
  FETCH_MY_STUDENTS_SUCCESS,
  FETCH_MY_STUDENTS_FAILURE,
  FETCH_MY_STUDENTS_RESET,
  FETCH_COACH_APP_HOURS_REQUEST,
  FETCH_COACH_APP_HOURS_SUCCESS,
  FETCH_COACH_APP_HOURS_FAILURE,
  FETCH_COACH_APP_HOURS_RESET,
FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_REQUEST,
  FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_SUCCESS,
  FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_FAILURE,
  FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_RESET,

} from "./CoachAnalyticsTypes";

const initialMyStudentsState = {
  loading: false,
  students: [],
  error: "",
};

export const fetchMyStudentsReducer = (
  state = initialMyStudentsState,
  action
) => {
  switch (action.type) {
    case FETCH_MY_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_MY_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload,
        error: "",
      };
    case FETCH_MY_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        students: [],
        error: action.payload,
      };
    case FETCH_MY_STUDENTS_RESET:
      return {
        ...state,
        loading: false,
        students: [],
        error: "",
      };
    default:
      return state;
  }
};

const initialCoachAppHoursState = {
  loading: false,
  data: [],
  summary: null,
  error: "",
};

export const fetchCoachAppHoursReducer = (
  state = initialCoachAppHoursState,
  action
) => {
  switch (action.type) {
    case FETCH_COACH_APP_HOURS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_COACH_APP_HOURS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        summary: action.payload.summary,
        error: "",
      };
    case FETCH_COACH_APP_HOURS_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        summary: null,
        error: action.payload,
      };
    case FETCH_COACH_APP_HOURS_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        summary: null,
        error: "",
      };
    default:
      return state;
  }
};

const initialTotalLogSessionsOfStudentsState = {
  loading: false,
  data: [],
  error: "",
}; 
export const fetchTotalLogSessionsOfStudentsReducer = (
  state = initialTotalLogSessionsOfStudentsState,
  action
) => {
  switch (action.type) {
    case FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };
    case FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    case FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        error: "",
      };
    default:
      return state;
  }
};